  const validateEmail = (email) => {
  const reg = /^[^@]+@\w+(\.\w+)+\w$/;
  return reg.test(email);
}

const validate = () => {
  const message = document.querySelector('.subscribe-form__message');
  const email = document.getElementById('myEmail').value;

  if (validateEmail(email)) {
    message.innerHTML = 'Email is valid!'
    message.style.color = 'green';
  } else {
    message.innerHTML = 'Email is not valid!'
    message.style.color = 'red';
  }
}

document.querySelector('.subscribe-form').addEventListener('submit', (e) => {
  e.preventDefault();
  validate();
});
